__turbopack_context__.v({
  "knob": "theme-changer-button-module__9DkYjW__knob",
  "theme-name": "theme-changer-button-module__9DkYjW__theme-name",
  "themeChanger": "theme-changer-button-module__9DkYjW__themeChanger",
});
